/**
 * 테마 설정
 * 애플리케이션 전체에서 사용하는 색상, 브레이크포인트, 폰트 등을 중앙 관리합니다.
 */

const theme = {
  // 색상 팔레트
  colors: {
    // Primary Colors
    primary: '#e5857c',
    primaryHover: '#d16f68',
    primaryActive: '#c05f58',

    // Secondary Colors
    secondary: '#2679b2',
    accent: '#ea4336',

    // Grayscale
    black: '#000000',
    darkGray1: '#1b1b1b',
    darkGray2: '#212121',
    darkGray3: '#323232',
    gray1: '#333333',
    gray2: '#555555',
    gray3: '#616161',
    gray4: '#666666',
    lightGray1: '#b0b0b0',
    lightGray2: '#d0d0d0',
    lightGray3: '#d7d7d7',
    lightGray4: '#e8e8e8',
    white: '#ffffff',

    // Background Colors
    bgPrimary: '#ffffff',
    bgSecondary: '#fcf5f4',
    bgTertiary: '#f4f4f4',

    // Border Colors
    border: '#d7d7d7',
    borderLight: '#e8e8e8',
    borderDark: '#d0d0d0',

    // Text Colors
    textPrimary: '#333333',
    textSecondary: '#555555',
    textTertiary: '#666666',
    textLight: '#616161',
  },

  // 반응형 브레이크포인트
  breakpoints: {
    // 모바일 디바이스
    mobileS: '320px',   // iPhone SE
    mobileM: '375px',   // iPhone 12
    mobileL: '425px',   // Large phones

    // 태블릿
    tablet: '768px',    // iPad
    tabletL: '1024px',  // iPad Pro

    // 데스크톱
    desktop: '1350px',  // Desktop minimum
    desktopL: '1920px', // Large desktop
  },

  // 미디어 쿼리 헬퍼
  media: {
    mobileS: `(min-width: 320px)`,
    mobileM: `(min-width: 375px)`,
    mobileL: `(min-width: 425px)`,
    tablet: `(min-width: 768px)`,
    tabletL: `(min-width: 1024px)`,
    desktop: `(min-width: 1350px)`,
    desktopL: `(min-width: 1920px)`,

    // Max-width 쿼리 (모바일 우선)
    maxMobile: `(max-width: 767px)`,
    maxTablet: `(max-width: 1023px)`,
    maxDesktop: `(max-width: 1349px)`,
  },

  // 폰트 패밀리
  fonts: {
    primary: "'koPubWorld DotumM', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    bold: "'koPubWorld DotumB', sans-serif",
    mapo: "'MapoPeacefull', sans-serif",
    nanumBold: "'Nanum Gothic Bold', sans-serif",
    nanumSquare: "'Nanum Square Bold', sans-serif",
  },

  // 폰트 크기 (반응형 대응)
  fontSizes: {
    xs: 'clamp(10px, 2vw, 12px)',
    sm: 'clamp(12px, 2.5vw, 14px)',
    base: 'clamp(14px, 3vw, 16px)',
    md: 'clamp(16px, 3.5vw, 18px)',
    lg: 'clamp(18px, 4vw, 20px)',
    xl: 'clamp(20px, 4.5vw, 24px)',
    '2xl': 'clamp(24px, 5vw, 28px)',
    '3xl': 'clamp(28px, 5.5vw, 32px)',
    '4xl': 'clamp(32px, 6vw, 36px)',
  },

  // 간격 (spacing)
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px',
  },

  // 그림자
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },

  // 트랜지션
  transitions: {
    fast: '150ms ease-in-out',
    base: '250ms ease-in-out',
    slow: '350ms ease-in-out',
  },

  // z-index 레벨
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },

  // 레이아웃 관련
  layout: {
    maxWidth: '1020px',      // 데스크톱 최대 너비
    minWidth: '320px',       // 모바일 최소 너비
    containerPadding: '20px', // 기본 컨테이너 패딩
  },
};

export default theme;
